"use client";
import { OTPInput as BaseOTPInput } from "input-otp";

import { cn } from "@/utils";

import type { OTPInputProps as BaseProps, SlotProps } from "input-otp";

function FakeCaret() {
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center animate-caret-blink">
      {/* shorter caret on small screens */}
      <div className="h-6 w-px bg-[#0F3B3D] sm:h-7 md:h-8" />
    </div>
  );
}

function Slot(props: SlotProps) {
  const active = props.isActive;
  return (
    <div
      className={cn(
        // ↓ shrink box on small screens, scale up at sm/md
        "relative flex items-center justify-center rounded-xl border border-transparent bg-[#F2F2F2]",
        "h-12 w-10 text-lg sm:h-14 sm:w-12 sm:text-xl md:h-16 md:w-14 md:text-2xl",
        active &&
          "border-[#B8860B] bg-white ring-2 ring-[#B8860B] shadow-[0_0_0_1px_rgba(184,134,11,0.35)]",
      )}
    >
      <div className="group-has-[input[data-input-otp-placeholder-shown]]:opacity-20">
        {props.char ?? props.placeholderChar}
      </div>
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  );
}

type OTPInputProps = Pick<BaseProps, "maxLength" | "onComplete"> & {
  /** Optional: force compact mode always */
  compact?: boolean;
};

export default function OTPInput({
  maxLength = 6,
  onComplete,
  compact,
}: OTPInputProps) {
  return (
    <BaseOTPInput
      autoFocus
      inputMode="numeric"
      onComplete={onComplete}
      maxLength={maxLength}
      // center and allow the whole row to fit narrow screens
      containerClassName={cn(
        "group flex items-center justify-start has-[:disabled]:opacity-30",
      )}
      render={({ slots }) => (
        // ↓ tighter gaps on mobile, larger on bigger screens
        <div
          className={cn(
            "flex",
            compact ? "gap-1.5" : "gap-2 sm:gap-3 md:gap-4",
          )}
        >
          {slots.map((slot, idx) => (
            <div key={idx}>
              <Slot {...slot} />
            </div>
          ))}
        </div>
      )}
    />
  );
}
